<template>
  <div>
    <spinner
      :size="size"
      :spacing="40"
      message=""
      :line-fg-color="$primaryColor"
    />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'medium'
    }
  }
}
</script>
